import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sample-general-titles',
  templateUrl: './sample-general-titles.component.html',
  styleUrls: ['./sample-general-titles.component.scss']
})
export class SampleGeneralTitlesComponent implements OnInit {

  @Input() block: any;
  @Input() title: any;
  @Input() subtitle: any;

  constructor() { }

  ngOnInit(): void {
  }

}
